import { useUIColors } from '@/core/hooks';
import IdCardSvg from '@assets/images/svg/id-card.svg';
import React from 'react';
import { View } from 'react-native';

export interface IdCardIconProps {
    size?: number;
    color?: string;
    strokeWidth?: number;
}

export function IdCardIcon({ size = 24, color, strokeWidth = 2 }: IdCardIconProps) {
    const colors = useUIColors();
    const strokeColor = color || colors.vectorsIconGreyscale;

    return (
        <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
            <IdCardSvg width={size} height={size} color={strokeColor} strokeWidth={strokeWidth} />
        </View>
    );
}

export default IdCardIcon;